import React from 'react';
import styled from 'styled-components';
import Badge from '../../../../../common/src/components/Badge';
import { mq } from '../../../../../common/src/utils/styledComponentsUtils';

// Components

interface Props {
  Icon: React.ReactElement;
  title: string;
  label?: string;
  active?: boolean;
  onClick?: () => void;
}

const OffersFilterBarItem: React.FC<React.PropsWithChildren<Props>> = ({
  Icon,
  title,
  label,
  active,
  onClick,
}) => {
  return (
    <Wrapper active={active} hasLabel={!!label} onClick={onClick}>
      {Icon}
      <Label active={active}>{title}</Label>
      {label && <StyledBadge type="PRIMARY">{label}</StyledBadge>}
    </Wrapper>
  );
};

const StyledBadge = styled(Badge)`
  display: none;

  ${mq.laptop} {
    display: block;
    font-size: 0.8rem;
  }
`;

const Label = styled.p<{ active?: boolean }>`
  font-size: 1.4rem;
  transition: 0.2s;
  line-height: 120%;
  word-wrap: break-word;
  max-width: 95%;
  margin-top: 0.8rem;
  text-align: center;

  color: ${({ active, theme }) =>
    active ? theme.primary[500] : theme.labels.guaranteeText};

  ${mq.laptop} {
    margin-top: 0;
    margin-right: 0.8rem;
  }
`;

const Wrapper = styled.div<{ active?: boolean; hasLabel?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
  height: 100%;
  padding: 4px;

  > svg {
    path {
      transition: 0.2s;
      fill: ${({ active, theme }) =>
        active ? theme.primary[500] : theme.gray[200]};
    }
  }

  > div:first-child {
    font-size: 1.2rem;
  }
  background-color: ${({ active, theme }) =>
    active ? theme.primary[50] : theme.gray[50]};

  border-radius: 6px;

  ${mq.laptop} {
    height: 5.6rem;
    width: 100%;
    flex-direction: row;
    justify-content: center;

    cursor: pointer;
    transition: 0.2s;
    &:hover {
      opacity: 0.8;
    }

    > svg {
      display: ${({ hasLabel }) => (hasLabel ? 'none' : 'block')};
    }
    ${mq.laptopL} {
      > svg {
        display: block;
      }
    }
  }
`;

export default OffersFilterBarItem;
